// extracted by mini-css-extract-plugin
export default {"reviews-block":"styles_reviews-block__jyqrV","reviews-list":"styles_reviews-list__DuHUG"};